import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { AirlineResponse } from "@/models/api/administration/airlines/Airline";
import { Airline } from "@/models/api/administration/airlines/Airline";
import { AirlineEditAdd } from "@/models/api/administration/airlines/AirlineEditAdd";

//#region Routes
export const URL_GET_AIRLINE_PAGED = "/Airline/Paged";
export const URL_GET_AIRLINE_BY_ID = "/Airline/${AirlineId}";
export const URL_POST_EDIT_AIRLINE = "/Airline/${AirlineId}/Edit";
export const URL_POST_REMOVE_AIRLINE = "/Airline/${AirlineId}/Remove";
export const URL_POST_ADD_AIRLINE = "/Airline/Add";
export const URL_POST_CHANGE_AIRLINE_CONTRACTOR = "/Airline/Contractor/${AirlineId}/${ContractorId}";
export const URL_POST_REMOVE_AIRLINE_CONTRACTOR = "/Airline/Contractor/${AirlineId}/Remove";
//#endregion

const _getAirlineTable = new CancellableHelper<AirlineResponse>(URL_GET_AIRLINE_PAGED, AirlineResponse);
_getAirlineTable.jsonSerializer = true;
export const getAirlineTable = async (genericTableRequest: GenericTableRequest): Promise<AirlineResponse> => {
  return await _getAirlineTable.get(genericTableRequest);
};

const _getAirlineById = new CancellableHelper<Airline>(URL_GET_AIRLINE_BY_ID, Airline);
export const getAirlineById = async (airlineId: number): Promise<Airline> => {
  return await _getAirlineById.get({ AirlineId: airlineId });
};

const _editAirline = new CancellableHelper<null>(URL_POST_EDIT_AIRLINE);
export const editAirline = async (id: number, airlineModel: AirlineEditAdd): Promise<null> => {
  return await _editAirline.post({ AirlineId: id }, airlineModel);
};

const _addAirline = new CancellableHelper<null>(URL_POST_ADD_AIRLINE);
export const addAirline = async (airlineModel: AirlineEditAdd): Promise<null> => {
  return await _addAirline.post(null, airlineModel);
};

const _removeAirline = new CancellableHelper<null>(URL_POST_REMOVE_AIRLINE);
export const removeAirline = async (id: number): Promise<null> => {
  return await _removeAirline.post({ AirlineId: id });
};

const _changeAirlineContractor = new CancellableHelper<null>(URL_POST_CHANGE_AIRLINE_CONTRACTOR);
export const changeAirlineContractor = async (airlineId: number, contractorId: string): Promise<null> => {
  return await _changeAirlineContractor.post({ AirlineId: airlineId, ContractorId: contractorId });
};

const _removeAirlineContractor = new CancellableHelper<null>(URL_POST_REMOVE_AIRLINE_CONTRACTOR);
export const removeAirlineContractor = async (airlineId: number): Promise<null> => {
  return await _removeAirlineContractor.post({ AirlineId: airlineId });
};
